"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ThWithoutDocs = (0, _context.styledWithTheme)('th')(function (_ref) {
  var selectors = _ref.theme.selectors,
      hasStickyHeader = _ref.hasStickyHeader,
      isSortable = _ref.isSortable,
      isStriped = _ref.isStriped,
      scope = _ref.scope,
      spacing = _ref.spacing,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? _constants.thDefaultProps.textAlign : _ref$textAlign,
      width = _ref.width;
  var paddingHorizontal = (0, _utils.px)(selectors.space(_constants.CELL_SPACING_HORIZONTAL));
  var paddingVertical = (0, _utils.px)(selectors.space(spacing === _interfaces.TableSpacing.Reduced ? _constants.HEADER_SPACING_VERTICAL_REDUCED : _constants.HEADER_SPACING_VERTICAL));
  return _objectSpread(_objectSpread({}, hasStickyHeader && {
    position: 'sticky',
    top: 0,
    zIndex: 2
  }), {}, {
    verticalAlign: 'middle',
    textAlign: textAlign,
    width: width,
    fontWeight: 'inherit',
    // The 'height' rule ensures table header cells are consistent in
    // height on hover. Removing this breaks Firefox (Chrome and
    // Safari seem fine).
    height: '100%',
    backgroundColor: selectors.color(isStriped ? _constants.BACKGROUND_COLOR_HEADER_STRIPED : _constants.BACKGROUND_COLOR_HEADER),
    padding: !isSortable ? "".concat(paddingVertical, " ").concat(paddingHorizontal) : '0 !important'
  }, scope !== 'row' ? {
    borderBottom: "".concat(_constants.BORDER_WIDTH_INNER, "px solid ").concat(selectors.color(_constants.BORDER_COLOR))
  } : {});
});
var Th = (0, _stencilReactDesc.describe)(ThWithoutDocs).description("Stencil-styled HTML 'th' element.");
Th.propTypes = _objectSpread(_objectSpread({}, _propTypes.widthPropTypes), {}, {
  textAlign: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'text-align' property for the element.")
});
Th.defaultProps = _objectSpread({}, _constants.thDefaultProps);
Th.displayName = 'Th';
var _default = Th;
exports.default = _default;